const divActionLogs = {
  update: 'Actualización',
  comments: 'Comentario',
  update_at: 'actualizado '
};

export default divActionLogs;
